Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "Site", {
    enumerable: true,
    get: function() {
        return Site;
    }
});
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
class Site {
    findMarketByLocale(locale) {
        return this.marketLookups.get(locale.toLowerCase());
    }
    findMarketByCountryCode(countryCode) {
        return this.marketByCountryLookups.get(countryCode.toLowerCase());
    }
    constructor(siteDef, env, allMarkets){
        _define_property(this, "env", void 0);
        _define_property(this, "uid", void 0);
        _define_property(this, "name", void 0);
        _define_property(this, "domain", void 0);
        _define_property(this, "subdomain", void 0);
        _define_property(this, "subpath", void 0);
        _define_property(this, "prodDomain", void 0);
        _define_property(this, "url", void 0);
        _define_property(this, "markets", void 0);
        _define_property(this, "defaultMarket", void 0);
        _define_property(this, "marketLookups", void 0);
        _define_property(this, "marketByCountryLookups", void 0);
        this.env = env;
        this.uid = siteDef.uid;
        this.name = siteDef.name;
        this.subdomain = siteDef.subdomain;
        this.subpath = siteDef.subpath;
        this.prodDomain = siteDef.domain;
        this.markets = siteDef.marketUids.map((marketUid)=>allMarkets.find((market)=>market.uid === marketUid));
        this.defaultMarket = this.markets.find((market)=>market.uid === siteDef.defaultMarketUid);
        switch(env){
            case 'prod':
                this.domain = siteDef.domain;
                break;
            default:
                this.domain = `${env}-${siteDef.domain}`;
                break;
        }
        this.url = `${this.subdomain ? `${this.subdomain}.` : ''}${this.domain}${this.subpath ?? ''}`;
        this.marketLookups = new Map();
        this.marketByCountryLookups = new Map();
        this.markets.forEach((market)=>{
            this.marketLookups.set(market.marketLocale.toLowerCase(), market);
            market.countries.forEach((country)=>{
                this.marketLookups.set(`${market.lang}-${country.code}`.toLowerCase(), market);
                if (country.defaultLang === market.lang) {
                    this.marketByCountryLookups.set(country.code.toLowerCase(), market);
                }
            });
        });
    }
}
